export default {"src":"/_next/static/media/firebase_logo_b9c786dd7d.3c12283e.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};